import React, { useRef, useEffect } from 'react';
import "./navbar.css";
import previewVideo from "../../assets/preview-video.mp4";
import { useLanguage } from '../../context/LanguageContext';

const PreviewModal = () => {
    const { t, changeLanguage } = useLanguage();
    const videoRef = useRef(null);

    useEffect(() => {
        const modalElement = document.getElementById('previewModal');
        const handleModalClose = () => {
            if (videoRef.current) {
                videoRef.current.pause();
                videoRef.current.currentTime = 0;
            }
        };
        modalElement?.addEventListener('hidden.bs.modal', handleModalClose);

        return () => {
            modalElement?.removeEventListener('hidden.bs.modal', handleModalClose);
        };
    }, []);

    return (
        <div>
            <div className="modal fade" id="previewModal" tabindex="-1" aria-labelledby="previewModalLabel" aria-hidden="true">
                <div className="modal-dialog preview-modal-dialog">
                    <div className="modal-content preview-modal-content">
                        <div className="modal-header">
                            <h1 className="modal-title fs-5" id="previewModalLabel">{t('pdi-preview')}</h1>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            <video className='preview-video' ref={videoRef} src={previewVideo} controls></video>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PreviewModal;
